import { useState, useEffect } from "react";
import "./App.css";
import { lessons, vocabs, audios, intros } from "./lessons/chinese/index";
import M from "materialize-css";

function App() {
  const [currLesson, setCurrLesson] = useState(1);
  const [sideNav, setSideNav] = useState<M.Sidenav[] | null>(null);
  const [cardLang, setCardLang] = useState(0);
  const [feedback, setFeedback] = useState(false);

  function openSideNav() {
    if (sideNav) sideNav[0].open();
  }

  function capitalize(str: string, idx: number) {
    if (idx === 0) return str.charAt(0).toUpperCase() + str.slice(1);
    return str;
  }

  function switchLesson(newLesson: number) {
    setFeedback(false);
    setCurrLesson(newLesson);
    if (sideNav) sideNav[0].close();
  }

  function changeCardLang() {
    setCardLang((cardLang + 1) % 2);
  }

  function generateTranscript() {
    const transcriptArray = ["<speak>", "<prosody rate='65%'>"];
    for (const phrase of lessons[currLesson]) {
      const sentence = [];
      for (const word of phrase.literal) {
        // @ts-ignore: Unreachable code error
        sentence.push(vocabs[currLesson][word][1]);
      }
      transcriptArray.push(sentence.join(""));
    }
    transcriptArray.push("</prosody>", "</speak>");
    const transcriptString = transcriptArray.join("\n");
    console.log(transcriptString);
  }

  function updateSpeed(val: number) {
    const player = document.getElementsByTagName("audio")[0];
    player.playbackRate = val;
  }

  useEffect(() => {
    const sidenavs = document.querySelectorAll(".sidenav");
    const sidenavInstance = M.Sidenav.init(sidenavs, {});
    setSideNav(sidenavInstance);

    const tooltips = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(tooltips, {});

    const dropdowns = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdowns, {});

    const floatingActionButtons =
      document.querySelectorAll(".fixed-action-btn");
    M.FloatingActionButton.init(floatingActionButtons, {});

    const modals = document.querySelectorAll(".modal");
    M.Modal.init(modals, {});
  }, []);

  useEffect(() => {
    const tooltips = document.querySelectorAll(".tooltipped");
    M.Tooltip.init(tooltips, {});
  }, [cardLang, currLesson]);

  return (
    <div>
      <div className="row">
        <nav className="nav-extended">
          <div className="nav-wrapper left-padding">
            <a
              href="!#"
              className="brand-logo center"
              onClick={generateTranscript}
            >
              Audio Dict
            </a>
            <ul className="left">
              <li>
                <a href="#!" onClick={openSideNav}>
                  <i className="material-icons">menu</i>
                </a>
              </li>
            </ul>
            {!feedback && (
              <ul className="right">
                <li
                  className="tooltipped"
                  data-position="left"
                  // @ts-ignore: Unreachable code error
                  data-tooltip="Vocabulary"
                >
                  <a href="#vocab-modal" className="modal-trigger">
                    <i className="material-icons">import_contacts</i>
                  </a>
                </li>
              </ul>
            )}
          </div>
        </nav>
      </div>
      <div id="vocab-modal" className="modal modal-fixed-footer">
        <div className="modal-content">
          <h4 className="center-align">Vocab - Lesson {currLesson}</h4>
          <table className="centered striped">
            <thead>
              <tr>
                <th>English</th>
                <th>Phonetics</th>
                <th>Chinese</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(vocabs[currLesson]).map(
                ([english, [phonetics, chinese]]) => (
                  <tr>
                    <td>{english}</td>
                    <td>{phonetics}</td>
                    <td>{chinese}</td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <div className="modal-footer">
          <a
            href="#!"
            className="modal-close waves-effect waves-green btn-flat"
          >
            Close
          </a>
        </div>
      </div>
      <div className="row">
        <ul className="sidenav" id="slide-out">
          <li onClick={() => switchLesson(1)}>
            <a href="#!">Lesson 1</a>
          </li>
          <li onClick={() => switchLesson(2)}>
            <a href="#!">Lesson 2</a>
          </li>
          <li onClick={() => switchLesson(3)}>
            <a href="#!">Lesson 3</a>
          </li>
          <li onClick={() => switchLesson(4)}>
            <a href="#!">Lesson 4</a>
          </li>
          <li onClick={() => switchLesson(5)}>
            <a href="#!">Lesson 5</a>
          </li>
          <li onClick={() => switchLesson(6)}>
            <a href="#!">Lesson 6</a>
          </li>
          <li onClick={() => switchLesson(7)}>
            <a href="#!">Lesson 7</a>
          </li>
          <li onClick={() => switchLesson(8)}>
            <a href="#!">Lesson 8</a>
          </li>
          <li
            onClick={() => {
              setFeedback(true);
              if (sideNav) sideNav[0].close();
            }}
          >
            <a href="#!">Lesson 9</a>
          </li>
        </ul>
      </div>
      {feedback && (
        <center>
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSel6SqAyxd7ZCOgkMNF1z23qAI1UpvA4agpsMH7vc1yrRES4w/viewform?embedded=true"
            width="100%"
            height="1470"
            frameBorder="0"
            marginHeight={0}
            marginWidth={0}
            title="feedback"
          >
            Loading�
          </iframe>
        </center>
      )}
      {!feedback && (
        <div>
          <div className="row">
            <center>
              <h3>Chinese - Lesson {currLesson}</h3>
            </center>
          </div>
          {intros[currLesson] && (
            <div className="row">
              <div className="col s12 m6 l4 offset-m3 offset-l4">
                <div className="card">
                  <div className="card-content">
                    <h6>{intros[currLesson]}</h6>
                  </div>
                </div>
              </div>
            </div>
          )}
          {audios[currLesson] && (
            <div>
              <div className="row">
                <audio
                  loop
                  controls
                  className="col s12 m6 l4 offset-m3 offset-l4"
                  src={`https://docs.google.com/uc?export=download&id=${audios[currLesson]}`}
                ></audio>
              </div>
              <div className="row">
                <center>
                  <a
                    href={`https://drive.google.com/uc?authuser=0&id=${audios[currLesson]}&export=download`}
                    className="download-btn waves-effect waves-light btn  blue-grey lighten-5
 grey-text text-darken-4"
                  >
                    <i className="material-icons right">cloud_download</i>
                    Download
                  </a>
                  <a
                    className="dropdown-trigger speed-btn waves-effect waves-light btn blue-grey lighten-5
                 grey-text text-darken-4 speed-dropdown"
                    href="#!"
                    data-target="speed-dropdown"
                  >
                    <i className="material-icons right">settings</i>
                    Speed
                  </a>
                  <ul id="speed-dropdown" className="dropdown-content">
                    <li onClick={() => updateSpeed(0.5)}>
                      <a href="#!" className="grey-text text-darken-3">
                        0.5x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(0.6)}>
                      <a href="#!" className="grey-text text-darken-3">
                        0.6x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(0.7)}>
                      <a href="#!" className="grey-text text-darken-3">
                        0.7x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(0.8)}>
                      <a href="#!" className="grey-text text-darken-3">
                        0.8x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(0.9)}>
                      <a href="#!" className="grey-text text-darken-3">
                        0.9x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.0)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.0x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.1)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.1x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.2)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.2x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.3)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.3x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.4)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.4x
                      </a>
                    </li>
                    <li onClick={() => updateSpeed(1.5)}>
                      <a href="#!" className="grey-text text-darken-3">
                        1.5x
                      </a>
                    </li>
                  </ul>
                </center>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col s12 m6 l4 offset-m3 offset-l4">
              <div className="card">
                <div className="card-content">
                  <span className="card-title">Transcript</span>
                  <div>
                    {lessons[currLesson].map((phrase) => (
                      <div>
                        {cardLang === 0 && (
                          <h6>
                            {phrase.literal.map((key, idx, arr) => (
                              <span
                                className="tooltipped"
                                data-position="top"
                                // @ts-ignore: Unreachable code error
                                data-tooltip={key}
                              >
                                {`${capitalize(
                                  // @ts-ignore: Unreachable code error
                                  vocabs[currLesson][key][0],
                                  idx
                                )}${
                                  idx + 1 < arr.length &&
                                  (arr[idx + 1] === "." ||
                                    arr[idx + 1] === "," ||
                                    arr[idx + 1] === "!")
                                    ? ""
                                    : " "
                                }`}
                              </span>
                            ))}
                          </h6>
                        )}
                        {cardLang === 1 && (
                          <h6>
                            {phrase.translated.map((key, idx, arr) => (
                              <span
                                className="tooltipped"
                                data-position="top"
                                // @ts-ignore: Unreachable code error
                                data-tooltip={vocabs[currLesson][key][0]}
                              >
                                {`${capitalize(key, idx)}${
                                  idx + 1 < arr.length &&
                                  (arr[idx + 1] === "." ||
                                    arr[idx + 1] === "," ||
                                    arr[idx + 1] === "?" ||
                                    arr[idx + 1] === "!")
                                    ? ""
                                    : " "
                                }`}
                              </span>
                            ))}
                          </h6>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed-action-btn">
            <a
              href="#!"
              className="btn-floating btn-large red"
              onClick={changeCardLang}
            >
              <i className="large material-icons">translate</i>
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
